module.exports = __webpack_public_path__ + "public/img/default-img.fe203b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/default-img.jpg
// module id = 19
// module chunks = 3 4